import styled from 'styled-components'

// Fixed header (72px) + sticky status notification bar (40px)
export const SITE_PROPOSAL_HEADER_OFFSET = '112px'

export const KbaCriteriaSummaryWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 16px 32px 8px;
  margin-top: ${(props) => props.marginTop ?? SITE_PROPOSAL_HEADER_OFFSET};
`

export const KbaCriteriaSummaryLine = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: baseline;
  gap: 6px;
  max-width: 960px;
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const KbaCriteriaSummaryLabel = styled.span`
  font-weight: 600;
  color: rgba(32, 32, 32, 0.72);
  flex-shrink: 0;
`

export const KbaCriteriaSummaryValues = styled.span`
  color: #0aa1f4;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
`
